import { lazy, Suspense } from 'react';

const LazyComponent = lazy(() =>
    import(
        /* webpackChunkName: "SbSharedNullSearchRelatedItemsFollow" */ './SbSharedNullSearchRelatedItemsFollow'
    )
);

export const SbSharedNullSearchRelatedItemsFollowLazy = props => (
    <Suspense fallback="">
        <LazyComponent {...props} />
    </Suspense>
);
